import * as React from 'react';

import {PreferencesPageContainer} from './containers';

interface Props {}

export const PreferencesPage: React.FC<Props> = () => {
    return (
        <PreferencesPageContainer />
    );
};
